import type { Campaign } from '@datapad/data-model';
import { Today } from '@mui/icons-material';
import { Box, ListItemButton, ListItemIcon, ListItemText, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import type React from 'react';
import {
	menuItemBorderRadius,
	menuLabelSx,
	menuLabelTypographyVariant,
	menuSectionSx,
} from './Constants';

/**
 * {@link CampaignDetails} input props.
 */
export interface CampaignDetailsProps {
	/**
	 * The campaign to display.
	 */
	readonly campaign: Campaign;

	/**
	 * Callback when the campaign date is clicked.
	 */
	onClick(): void;
}

/**
 * Datapad menu campaign details section displaying the current campaign date.
 *
 * @remarks
 * Clicking the date navigates to the Calendar app at that date.
 */
export function CampaignDetails(props: CampaignDetailsProps): React.ReactElement | null {
	const { campaign, onClick } = props;

	const campaignDate = campaign.currentDate;

	if (!campaignDate) {
		return null;
	}

	return (
		<Box sx={menuSectionSx}>
			<Typography variant={menuLabelTypographyVariant} sx={menuLabelSx}>
				{"Today's Date"}
			</Typography>
			<ListItemButton
				onClick={onClick}
				sx={(theme) => ({
					borderRadius: menuItemBorderRadius,
					'&:hover': {
						bgcolor: alpha(theme.palette.primary.main, 0.08),
					},
					transition: theme.transitions.create(['background-color'], {
						duration: theme.transitions.duration.short,
					}),
				})}
			>
				<ListItemIcon sx={{ minWidth: 40 }}>
					<Today color="primary" />
				</ListItemIcon>
				<ListItemText primary={campaignDate.toLongString()} />
			</ListItemButton>
		</Box>
	);
}
